import { render, staticRenderFns } from "./number.vue?vue&type=template&id=2f0df7f5&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports